export default __webpack_public_path__ + "static/3-cc86b7322bcad7b93f06aac1e98e9f16.jpeg";